import { gql } from "graphql-request";

export const READ_INTERACTION_BY_ID = gql`
  query ReadInteractionByID($id: ID!) {
    readInteractionByID(id: $id) {
      id
      contactID
      type
      direction
      summary
      notes
      valueAction
      meaningful
      happenedAt
    }
  }
`;

export const READ_RECENT_INTERACTIONS = gql`
  query ReadRecentInteractions($limit: Int) {
    readRecentInteractions(limit: $limit) {
      id
      contactID
      type
      direction
      summary
      notes
      valueAction
      meaningful
      happenedAt
    }
  }
`;

export const READ_ARCHIVED_INTERACTIONS = gql`
  query ReadArchivedInteractions($limit: Int) {
    readArchivedInteractions(limit: $limit) {
      id
      contactID
      type
      direction
      summary
      notes
      valueAction
      meaningful
      happenedAt
    }
  }
`;

export const READ_INTERACTIONS_BY_CONTACT = gql`
  query ReadInteractionsByContact($contactID: ID!, $limit: Int) {
    readInteractionsByContact(contactID: $contactID, limit: $limit) {
      id
      contactID
      type
      direction
      summary
      notes
      valueAction
      meaningful
      happenedAt
    }
  }
`;